import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { FetchClientUsersResponse } from "./FetchClientUsersResponse";

const ENDPOINT = "/usermanagement/users";

export class FetchClientUsersCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<FetchClientUsersResponse> {
        var res = await this.executeCommand();
        return new FetchClientUsersResponse(res);
    }
}
